module.exports = __webpack_public_path__ + "img/retrospect-16.d5a754ed.jpg";